import { PagePath } from '@packages/shared/core/common/constants/routes';
import { joinUrls } from '@packages/shared/core/common/utils/url';

export function getExpertPagePath(slug: string): string {
  return joinUrls(PagePath.EXPERT, slug);
}
